import { render, staticRenderFns } from "./myAssets.vue?vue&type=template&id=a8bde23e&scoped=true"
import script from "./myAssets.vue?vue&type=script&lang=js"
export * from "./myAssets.vue?vue&type=script&lang=js"
import style0 from "./myAssets.vue?vue&type=style&index=0&id=a8bde23e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8bde23e",
  null
  
)

export default component.exports